import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.onBackdrop = this.onBackdrop.bind(this)
    this.element.addEventListener("click", this.onBackdrop)

    if (!this.element.open) this.element.showModal()
  }

  disconnect() {
    this.element.removeEventListener("click", this.onBackdrop)
  }

  close() {
    this.element.close()
  }

  onBackdrop(event) {
    if (event.target === this.element) this.close()
  }
}
